import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {firestoreConnect, withFirestore} from "react-redux-firebase";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import {connect} from "react-redux";
import {COMPANY_DB_PATH, EMPLOYEE_DB_PATH} from "../../constants/DB_PATHS";
import {setCompanyData} from "../../redux/register/action";
import {ACCEPTED, WAITING_FOR_DECISION} from "../../utils/employeeStatus";
import {PROFILE_URL} from "../../constants/URLS";
import {exitUserFromCompany, signUpToCompany} from "../../utils/AuthFunctions";

class EmployeeSettings extends Component {

    render() {
        console.log(this.props)
        if(this.props.profile &&
            this.props.profile.employeeStatus &&
            this.props.profile.employeeStatus === ACCEPTED){
            return (
                <div>
                    <h3>{this.props.emp.employeeCompanyName}</h3>
                    <div>
                        <button onClick={async ()=>{
                            await exitUserFromCompany(
                                this.props.firestore,
                                this.props.auth.uid,
                                this.props.emp.employeeCompanyNameId,
                            )
                        }}>Exit</button>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <input type="text" value={this.props.companyRegister.employeeCompanyName}
                           onChange={(e) => {
                               this.props.setCompanyData({
                                   employeeCompanyName: e.target.value,
                               })
                           }}/>
                    {this.props.companies && this.props.companies.length !== 0 ?
                        <ul>
                            {Object.entries(this.props.companies).map((e, i) => {
                                return (
                                    <li key={i}>
                                        <span>{e[1].companyName}</span>
                                        <br/>
                                        <span>{e[1].id}</span>
                                        <button onClick={() => {
                                            this.props.setCompanyData({
                                                employeeCompanyNameId: e[1].id,
                                                employeeCompanyName: e[1].companyName,
                                                formFilled: true,
                                            })

                                        }}>choose
                                        </button>
                                    </li>
                                )
                            })}
                        </ul>
                        :
                        <div>
                            no company with this name
                        </div>
                    }
                    <button disabled={!this.props.companyRegister.formFilled} onClick={async ()=>{
                        await signUpToCompany(
                            this.props.firestore,
                            this.props.auth.uid,
                            this.props.companyRegister.employeeCompanyNameId,
                            this.props.companyRegister.employeeCompanyName,
                        )
                        await this.props.setCompanyData({
                            employeeCompanyNameId: '',
                            employeeCompanyName: '',
                            formFilled: false,
                        })
                        await this.props.history.push(PROFILE_URL)

                    }}>Update</button>
                </div>
            )
        }

    }
}

const mapStateToProps = state => {
    return {
        companyRegister: state.companyRegister
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setCompanyData: (data) => dispatch(setCompanyData(data, false)),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withFirestore,
    UserIsAuthenticated,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),


    firestoreConnect(props => {
            return [
                {
                collection: COMPANY_DB_PATH,
                where: [
                    ['companyName', '==', props.companyRegister.employeeCompanyName || ''],
                ]
                },
                {
                    collection: EMPLOYEE_DB_PATH,
                    doc: props.auth.uid,
                    storeAs: 'emp'
                }
            ]
        }
    ),
    connect((state, props) => ({
        companies: state.firestore.ordered[COMPANY_DB_PATH],
        emp: state.firestore.data.emp,
    })),
)(EmployeeSettings);